export const environment = {
    production: true,
    apiURL: 'https://search-hardman-test.sequation.net',
    SEARCH_API_KEY :'7a68984530caa5edd7c491bb912775db21724351c9b885217fa70fcdf9f4af8a',
    imgPath : 'https://hardman-test.sequation.net',
    refDataURL :'https://testservices.sequation.net',
    postCode_Search:'https://atlas.microsoft.com/search/fuzzy/json?subscription-key=efnLeNBZuGAgCaKOfwIm36SrJGHodA1gwqfUbtutHzI&api-version=1.0',
    reverse_Search:'https://atlas.microsoft.com/search/address/reverse/json?subscription-key=efnLeNBZuGAgCaKOfwIm36SrJGHodA1gwqfUbtutHzI&api-version=1.0',
    hardmanURL: 'https://hardman-test.sequation.net'
};